// Google search result preview + character counter used in the admin SEO tools.
export function CharCount({ value = '', max, min = 0 }) {
  const n = value.length;
  const tone = !n ? 'text-slate-400' : n > max || n < min ? 'text-amber-600' : 'text-emerald-600';
  return <span className={`text-[11px] font-mono ${tone}`}>{n}/{max}</span>;
}

export function GooglePreview({ url, title, description }) {
  const shortUrl = (url || '').replace(/^https?:\/\//, '').replace(/\//g, ' › ');
  const cut = (s, n) => (s && s.length > n ? `${s.slice(0, n - 1)}…` : s);
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 font-[Arial,sans-serif]" data-testid="google-preview">
      <p className="text-[11px] uppercase tracking-wider text-slate-400 mb-2 font-sans">Google-Vorschau</p>
      <p className="text-xs text-[#202124] truncate">{shortUrl}</p>
      <p className="text-[18px] leading-snug text-[#1a0dab] truncate">{cut(title, 62) || 'Seitentitel fehlt'}</p>
      <p className="text-[13px] leading-snug text-[#4d5156] line-clamp-2">{cut(description, 160) || 'Meta-Beschreibung fehlt'}</p>
    </div>
  );
}
